/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { CSSTransition } from 'react-transition-group';
export const WithCSSTransition = (props) => {
    const { in: visible, dimension = 'height', children, ...rest } = props;
    const expandedSize = React.useRef(0);
    const dimensionCamelCase = dimension === 'height' ? 'Height' : 'Width';
    return (React.createElement(CSSTransition, { in: visible, timeout: 200, unmountOnExit: true, onEnter: (node) => {
            node.style[`min${dimensionCamelCase}`] = 'initial';
            node.style[dimension] = '0px';
        }, onEntering: (node) => {
            node.style[dimension] = `${expandedSize.current}px`;
        }, onEntered: (node) => {
            node.style[`min${dimensionCamelCase}`] = '';
            node.style[dimension] = '';
        }, onExit: (node) => {
            node.style[dimension] = `${expandedSize.current}px`;
        }, onExiting: (node) => {
            node.style[`min${dimensionCamelCase}`] = 'initial';
            node.style[dimension] = '0px';
        }, classNames: 'iui', ...rest }, React.cloneElement(children, {
        ref: (el) => {
            if (el) {
                expandedSize.current = el.getBoundingClientRect()[dimension];
            }
        },
    })));
};
export default WithCSSTransition;
